import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const MarkAsDoneIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C6.89137 3 2.75 7.14137 2.75 12.25C2.75 17.3586 6.89137 21.5 12 21.5C17.1086 21.5 21.25 17.3586 21.25 12.25C21.25 11.7028 21.2026 11.167 21.1116 10.6465C20.7971 9.65569 22.1349 8.90459 22.5642 10.25C22.6862 10.8984 22.75 11.567 22.75 12.25C22.75 18.1871 17.9371 23 12 23C6.06294 23 1.25 18.1871 1.25 12.25C1.25 6.31294 6.06294 1.5 12 1.5C13.7491 1.5 15.4024 1.91829 16.8634 2.66066C17.8553 3.21595 17.0483 4.47281 16.1152 3.96337C14.8764 3.34686 13.4796 3 12 3Z"
      fill="#133C40"
      stroke="#133C40"
      strokeWidth="0.2"
      strokeLinecap="round"
    />
    <path
      d="M8.125 10.625C9.6566 12.1566 11.5874 14.0874 12.1128 14.6128C12.1878 14.6878 12.3092 14.6823 12.379 14.6025L21.875 3.75"
      stroke="#133C40"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
  </svg>
)
